import IMAGES from '../constants/images';

const getMembership = (category: string) => IMAGES.memberships[category.toLocaleLowerCase() as 'gold' | 'platinum' | 'diamond'];

export {
    getMembership,
};
